import { formatRecommendedAges } from '../helpers/helpers'

/** InfoWindow for map */
export function getInfoWindowLayout (activity) {
  const link = `/activities/${activity.slug}`
  return `
    <div id="${activity.name}" class="infowindow">
      <a href="${link}">
        <div class="infowindow-img-container">
          <img class="infowindow-img" src="${activity.main_image}" alt="${activity.slug}">
        </div>
        <div class="infowindow-data">
          <div class="infowindow-data-first">
            <h2 class="infowindow-name">
              <span>${activity.name}</span>
            </h2>
            <p class="infowindow-age">
              <span class="infowindow-icon"><i class="fas fa-child"></i></span>${formatRecommendedAges(JSON.parse(activity.recommended_ages))}
            </p>
            <p class="infowindow-address">
              <span class="infowindow-icon"><i class="fas fa-info"></i></span>${activity.subtitle}
            </p>
          </div>
          <div id="infowindow-book">Reserva</div>
        </div>
      </a>
    </div>
    `
}
